var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconmonstrPayment13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconmonstr",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "payment-13_1_",
    d: "M22,4H2C0.896,4,0,4.896,0,6v12c0,1.104,0.896,2,2,2h20c1.104,0,2-0.896,2-2V6C24,4.896,23.104,4,22,4z  M10.708,15.11h-1.33c-0.122,0-0.219-0.103-0.212-0.224C9.19,14.503,9.412,13.245,10.18,8.3C10.206,8.127,10.353,8,10.526,8h2.448 c1.31,0,2.277,0.769,2.01,2.147c-0.275,1.433-1.15,2.13-2.674,2.13l-0.753,0.001c-0.309,0.001-0.423,0.118-0.462,0.393L10.708,15.11 z M15.777,11.796c-0.282,1.473-1.249,1.982-2.483,1.982h-0.191c-0.151,0-0.279,0.111-0.303,0.263l-0.268,1.697 C12.509,15.889,12.381,16,12.23,16h-0.912c-0.13,0-0.229-0.116-0.209-0.244l0.462-2.96c0.002-0.011,0.01-0.019,0.021-0.019h0.718 c1.745,0,2.836-0.873,3.158-2.523c0.271,0.272,0.366,0.626,0.366,1C15.833,11.432,15.812,11.615,15.777,11.796z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmonstrPayment13);
export default __webpack_public_path__ + "static/media/iconmonstr-payment-13.5f45eaa5c8eef3315aac5d3d29fe8002.svg";
export { ForwardRef as ReactComponent };